// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { IcpFlow } from './containers/icp-flow/IcpFlow';
import { TenantLogin } from './containers/tenant-lookup/TenantLogin';
import type React from 'react';
import { LocaleProvider } from './i18n/localeProvider';
import ErrorBoundary from './errorHandler/ErrorBoundary';
import { ErrorView } from './errorHandler/ErrorView';
import { Notifications } from './errorHandler/context/Notifications';
// import '@ant-design/v5-patch-for-react-19';

export const App: React.FC = () => {
  const isTenantLookup = window.location.pathname.includes('tenant-lookup');

  if (isTenantLookup) {
    return (
      <LocaleProvider>
        <ErrorBoundary fallback={<ErrorView />}>
          <Notifications
            key={'tenant-lookup'}
            translationRoot={'tenant-lookup'}
          >
            <TenantLogin />
          </Notifications>
        </ErrorBoundary>
      </LocaleProvider>
    );
  }

  return <IcpFlow />;
};
